import FeatureLayer = require("esri/layers/FeatureLayer");
import MapImageLayer = require("esri/layers/MapImageLayer");
import Sublayer = require("esri/layers/support/Sublayer");
import PopupTemplate = require("esri/PopupTemplate");
import Query = require("esri/rest/support/Query");
import FieldInfo = require("esri/popup/FieldInfo");
import Info from "./../../widgets/Info";
import * as layerSource from "./layerSource";

export default class BuildPopups {
  

  static buildPopupIfLoaded(layer: any) {
    // console.log("Layer loaded - ", layer.title)
    if (layer.loaded) {
        // console.log("buildPopup if loaded - ", layer.title)
  //      setTimeout( () => {
          try {
            // console.log(" building popup ", layer.title);
            if (layer instanceof FeatureLayer) {
              if (!layer.popupTemplate) {
                layer.popupTemplate = this.buildPopupTemplate(layer as FeatureLayer);
              }
            }
            if (layer instanceof MapImageLayer) {
              const mapImageLayer = layer as MapImageLayer;
              mapImageLayer.sublayers.forEach(sublayer => {
                if (!sublayer.popupTemplate) {
                  this.buildPopupTemplateSublayer(sublayer);
                }
              });
            }
          } catch (error) {
              console.error("Error: in buildPopupIfLoaded " + error.message);
          }
  //      }, 10);
      } else {
        console.log("*****************  Layer not loaded ", layer.title)
      }
  }
  
  static buildPopupTemplateSublayer(layer: Sublayer) {
    try {

      let title = layer.title;
      if (title === null)
      {
        title = layer.sourceJSON.name;
      }
      // console.log("buildPopupTemplateSublayer ", title);
      const popupTemplate = new PopupTemplate({
        title: title + this.GetLayerDate(layer.id),
        content: [
          {
            type: "fields",
            fieldInfos: []
          }
        ]
      });
  
      const query: Query = new Query({
        returnGeometry: false,
        num: 1,
        outFields: ["*"]
      });
  
  
      if (layer.fields === null) {
        console.log("****************  layer has no fields, querying *************************")
        layer
          .queryFeatures(query)
          .then(({ fields }) => {
            fields.forEach(field => {
              if (
                field.name.toUpperCase().indexOf("OBJECTID") < 0 &&
                field.type !== "oid" &&
                field.name.toUpperCase().indexOf("SHAPE") < 0
              ) {
                popupTemplate.content[0].fieldInfos.push(
                  new FieldInfo({
                    fieldName: field.name,
                    label: field.alias ? field.alias : field.name
                  })
                );
              }
            });
  
            layer.popupTemplate = popupTemplate;
          })
          .catch(error => {
            console.error("Error: in buildPopupTemplateSublayer " + error.message + " layer " + layer.title);
          });
        } else {
          // console.log ("Layer has fields")
          layer.fields.forEach(field => {
            if (
              field.name.toUpperCase().indexOf("OBJECTID") < 0 &&
              field.type !== "oid" &&
              field.name.toUpperCase().indexOf("SHAPE") < 0
            ) {
              popupTemplate.content[0].fieldInfos.push(
                new FieldInfo({
                  fieldName: field.name,
                  label: field.alias ? field.alias : field.name
                })
              );
            }
          });
  
          layer.popupTemplate = popupTemplate;
      }
    } catch (error) {
      console.error("Error: in buildPopupTemplateSublayer " + error.message);
    }
  }
  
  static buildPopupTemplate(layer: FeatureLayer): PopupTemplate {
    // console.log(layer.title, " buildPopupTemplate FeatureLayer start");
  
    let title = layer.title;
    if (title === "RoadConditionQueryLayer") {
      title = "Pavement Condition";
    }
    const popupTemplate: PopupTemplate = new PopupTemplate({
      title: title + BuildPopups.GetLayerDate(layer.layerId),
      content: [
        {
          type: "fields",
          fieldInfos: []
        }
      ]
    });

    // Add the output fields to the popup template for IDOT Roads layer so the geometry is available on the selectedFeature. This was changed in 4.17:
    // https://community.esri.com/t5/arcgis-api-for-javascript-questions/hi-i-m-using-arcgis-javascript-api-4-17-and-it/m-p/428203/highlight/true#M39373
    if (title === "IDOT Roads") {
      popupTemplate.outFields = ["*"]
    }
  
    try {
      layer.fields.forEach(field => {
        if (
          field.name.toUpperCase().indexOf("OBJECTID") < 0 &&
          field.type !== "oid" &&
          field.name.toUpperCase().indexOf("SHAPE") < 0 && 
          !(
            title === "Pavement Condition" &&
            (
              field.name.toUpperCase().indexOf("LABELR") === 0 ||
              field.name.toUpperCase().indexOf("MARKED_RT") === 0
            )
          )
        ) {
          popupTemplate.content[0].fieldInfos.push(
            new FieldInfo({
              fieldName: field.name,
              label: field.alias ? field.alias : field.name
            })
          );
        }
      });
    } catch (error) {
      console.error("Error: in buildPopupTemplate " + error.message + " layer " + layer.title);
    }
    return popupTemplate;
  }

  static GetLayerDate(layerId: number) {
    let layerDate = "";

    switch (layerId) {
      case layerSource.NHSLayer:
      case layerSource.JurisdictionLayer:
      case layerSource.FunctionalClassLayer:
      case layerSource.SpeedLimitLayer:
      case layerSource.DTRSMTruckRoute:
      case layerSource.DTRLMTruckRouteWith:
      case layerSource.DTRLMTruckRouteAgainst:
        layerDate = Info.nightlyRoadDate;
        break;

      case layerSource.StateStructuresLayer:
      case layerSource.LocalStructuresLayer:
      case layerSource.DTRSMPostedStructures:
      case layerSource.DTRLMPostedStructures:
        layerDate = Info.structureDate;
        break;

      case layerSource.IDOTRoadsLayer:
      case layerSource.AnnualAverageDailyTraffic:
      case layerSource.HCVLayer:
      case layerSource.SULayer:
      case layerSource.MULayer:
        layerDate = Info.roadDate;
        break;
    }
 
    if (layerDate !== "" ) {
      return "<br><br>&nbsp;&nbsp;&nbsp;Data as of " + layerDate;
    }
    return "";
  }
}